export default __webpack_public_path__ + "static/media/IMG-20210926-WA0006.c64293be.jpg";